import { defineComponent as _defineComponent } from 'vue'
import { NeoIcon } from '@kodadot1/brick'


export default /*#__PURE__*/_defineComponent({
  __name: 'NeoTag',
  props: {
    isBlueTag: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {




const onClose = () => {
  emit('close')
}

return { __sfc: true,emit, onClose, NeoIcon }
}

})